import { api } from "..";

export interface SettingAuditEntry {
  id: number;
  settingKey: string;
  changedByUserId: number | null;
  changedByUsername: string | null;
  oldValue: unknown;
  newValue: unknown;
  createdAt: string;
}

export interface SettingAuditsPage {
  items: SettingAuditEntry[];
  total: number;
  page: number;
  pageSize: number;
}

// Admin change-history for app settings (who/when/old->new). Optional `key`
// filters to one setting (e.g. "crypto_sweep").
export async function getSettingAudits(
  params: { key?: string; page?: number; pageSize?: number } = {}
): Promise<SettingAuditsPage> {
  const res = await api.client.get("/app-settings/audit", { params });
  return res.data;
}
